import {moduloAutoconsumo} from "../diccionarios/autoconsumoModulo";
import {Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {UtilsService} from "../../../shared/utils/utils.service";
import {CommonService} from "../../../shared/utils/common.service";


@Injectable({
  providedIn: 'root'
})
export class AutoconsumoCreacionMantenedorService {

  diccionarioModulo: any;
  url: string;

  constructor(
    private http: HttpClient,
    private _util: UtilsService,
    private _commom: CommonService
  ) {
    this.diccionarioModulo = moduloAutoconsumo;
    this.url = this._util.getUrlAutoconsumo();
  }

  creacionMantenedor(payload) {
    return this._commom.peticionPostConHeader(this.url + this.diccionarioModulo.url.autoconsumo.mantenedor.creacion, payload);
  }

  getPorCliente(payload) {
    return this._commom.peticionGetConHeader(this.url + this.diccionarioModulo.url.autoconsumo.mantenedor.getByCliente + payload);
  }

  getAll() {
    return this._commom.peticionGetConHeaderSinMapeo(this.url + this.diccionarioModulo.url.autoconsumo.mantenedor.getAll);
  }

  validarCliente(payload) {
    return this._commom.peticionPostConHeader(this.url + this.diccionarioModulo.url.autoconsumo.mantenedor.validarCliente, payload);
  }

}
